export const ACTIVATION = {
  MANUAL: 1,
  AUTO: 2
};

export const VISUALIZATION = {
  IMMEDIATE: 1,
  TIMEOUT: 2
};

export const SHOW_WIDGET = {
  ALWAYS: 1,
  ONCE: 2,
  RECURRENTLY: 3
};

export const EXHIBITION_MODES = {
  BOX: 1,
  EMBEDDED: 2
};
